import { useCallback } from 'react';
import { useDatetime } from '../datetime/datetime-provider';
import { usePaymentData } from '../payment/payment-data-provider';
import { useServices } from '../service/services-provider';

export function useResetBookingState() {
  const { setSelectedDay, setSelectedTimeslot } = useDatetime();
  const { setCurrentService } = useServices();
  const { setCurrentStepToForm } = usePaymentData();

  return useCallback(() => {
    setCurrentService(undefined);
    setSelectedDay(undefined);
    setSelectedTimeslot(undefined);
    setCurrentStepToForm();
  }, [setCurrentStepToForm]);
}
